import { WEIGHT_BOLD } from "@hl/base-components/lib/theme/typography";
import {
  FEATURE_FLAGS,
  useFeatureFlags,
} from "@hl/shared-features/lib/features/auth/hooks/useFeatureFlags";
import { Box, Title } from "@mantine/core";

import { _CollectionType } from "apollo/graphql.generated";
import { TOOLS_URL } from "config";
import SelectCollectionCards from "~/features/collections/forms/CreateCollectionMultistepForm/SelectCollectionCards";

const CreateFirstCollection = () => {
  const enableGenSeries = useFeatureFlags(FEATURE_FLAGS.ENABLE_JOBS_GEN_SERIES);

  const collectionTypes = [
    _CollectionType.Series,
    _CollectionType.OpenEdition,
    _CollectionType.LimitedEdition,
    _CollectionType.OneOfOne,
  ].map((collectionType) => ({
    type: collectionType,
    to: TOOLS_URL.collections.createType.replace(
      ":collectionType",
      collectionType
    ),
  }));

  if (enableGenSeries) {
    collectionTypes.unshift({
      type: _CollectionType.GenerativeSeries,
      to: TOOLS_URL.collections.createType.replace(
        ":collectionType",
        _CollectionType.GenerativeSeries
      ),
    });
  }

  return (
    <Box
      sx={(theme) => ({
        padding: "40px 0",
        borderRadius: 20,
        backgroundColor: theme.colors.tableRowBackground[0],
      })}
    >
      <SelectCollectionCards
        title={
          <Title ta="center" order={5} fw={WEIGHT_BOLD}>
            Create your first collection
          </Title>
        }
        handlers={collectionTypes.map((collectionType) => ({
          type: collectionType.type,
          handler: {
            type: "link",
            to: collectionType.to,
          },
        }))}
      />
    </Box>
  );
};

export default CreateFirstCollection;
